
import { apiGet, apiPost, apiPut } from "./apiUtils";
import {  getLoggedInUserTenantID } from "./sessionUtil";

var users = 
[
    {
        "userName": "Admim1@gmail.com",
        "fullName": "Admin1",
        "phone": "202-893-2736",
        "userGroup": "Admin",
        "status": "ACTIVE",
    },
    {
       "userName": "Admin2@gmail.com",
       "fullName": "Admin2",
       "phone": "571-893-2736",
       "userGroup": "Admin",
       "status": "ACTIVE",
   },
   {
       "userName": "deployer1@gmail.com",
       "fullName": "Deployer1",
       "phone": "203-893-2736",
       "userGroup": "Deployer",
       "status": "ACTIVE",
   },
   {
       "userName": "deployer2@gmail.com",
       "fullName": "Deployer2",
       "phone": "204-893-2736",
       "userGroup": "Deployer",
       "status": "DISABLED",
   },
   {
       "userName": "designer1@gmail.com",
       "fullName": "Designer1",
       "phone": "205-893-2736",
       "userGroup": "Designer",
       "status": "ACTIVE",
   },
   {
       "userName": "designer2@gmail.com",
       "fullName": "Designer2",
       "phone": "206-893-2736",
       "userGroup": "Designer",
       "status": "ACTIVE",
   },
   {
       "userName": "apicaller3@gmail.com",
       "fullName": "Apicaller3",
       "phone": "202-893-2336",
       "userGroup": "APICaller",
       "status": "INACTIVE",
   },
   {
       "userName": "apicaller1@gmail.com",
       "fullName": "Apicaller1",
       "phone": "206-893-2736",
       "userGroup": "APICaller",
       "status": "ACTIVE",
   },
   {
       "userName": "apicaller2@gmail.com",
       "fullName": "Apicaller2",
       "phone": "207-893-2736",
       "userGroup": "APICaller",
       "status": "ACTIVE",
   },
   {
       "userName": "attended1@gmail.com",
       "fullName": "Attended1",
       "phone": "207-893-2737",
       "userGroup": "Attended",
       "status": "ACTIVE",
   },
   {
       "userName": "attended2@gmail.com",
       "fullName": "Attended2",
       "phone": "207-893-2735",
       "userGroup": "Attended",
       "status": "ACTIVE",
   },
   {
    "userName": "attended2@gmail.com",
    "fullName": "Attended2",
    "phone": "207-893-2735",
    "userGroup": "Attended",
    "status": "ACTIVE",
    },
 
]
;

export function getUsers() {

    /* 
     const res = fetch('https://t97k1ekiwb.execute-api.us-east-1.amazonaws.com/dev/getAgents');
     
     var rt = res.then((x) => x.json())
     .then((agents)=> JSON.parse(agents).Items)
     .catch(err => console.log(err));
      */
     
     let url = `${process.env.REACT_APP_API_PREFIX}/usermanagement/getUserListByTenant/${getLoggedInUserTenantID()}`
     return apiGet(url)
     .then(json=>{
    
         console.log(`Response result : ${json.result}`);
         console.log(`Response data : ${json.data}`);
         return json.data;        
 
     }).catch(err=> {
         console.log(`Error during getUsers ${err.message}`)
         throw new Error("Error duing getUsers");
     })
 
 
 }


 export function createUser(user){
    console.log("Adding user "+JSON.stringify(user));
    users.push(user);
 }

 export function updateUser(user){
    console.log("Update user" + JSON.stringify(user));
    var index = users.findIndex((u) => u.userName === user.userName);
    users[index].fullName = user.fullName;
    users[index].phone = user.phone;
    users[index].userGroup = user.userGroup;
 }

 export function deleteUser(user){
    console.log("Deleting user " + JSON.stringify(user))
   
    var index = users.findIndex((u) => u.userName === user.userName);
    users.splice(index,1);

 }

 export function getUserGroups(){
    const userGroups =["Admin","Designer","Deployer","APICaller","Attended"];
    return new Promise(function (resolve,reject){
        resolve(userGroups);

    }) ;
 
 }


 export function getLoggedInUserDetail(){
    return null;
 }


 